import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Loader, Dimmer } from "semantic-ui-react";
import axios from "axios";
import {
  formatMoneda,
  formatoMonto,
  validaMonto,
  validaSoloNumero,
  seleccionarCampo,
} from "../../util/varios";

import moment from "moment";
import CatalogoCuentaBancaria from "../../catalogos/catalogoCuentasBancarias";
import { Mensaje } from "../mensajes";

export const ImpMovBanLibro = (props) => {
  let op = require("../../../public/modulos/datos");
  let token = sessionStorage.getItem("jwtToken");
  let post = JSON.parse(sessionStorage.getItem("post"));
  const afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));

  const idefiscal = JSON.parse(sessionStorage.getItem("idefiscal"));
  const idusuario = JSON.parse(sessionStorage.getItem("idusuario"));
  const fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
  const anioefis = JSON.parse(sessionStorage.getItem("efiscalanio"));
  const [disabledInput, setDisabledInput] = useState(0);

  const [espiritu, setEspiritu] = useState(sessionStorage.getItem("espiritu"));
  const [activate, setActivate] = useState(false);
  const [mostrar5, setMostrar5] = useState(false);

  const [deshabilitado, setDeshabilitado] = useState(true);
  const [operacion, setOperacion] = useState(0);
  const [mostrar4, setMostrar4] = useState(false);
  const [cmbAnios, setCmbAnios] = useState();
  const [cmbMeses, setCmbMeses] = useState();
  const [val, setVal] = useState(0);
  const [val2, setVal2] = useState(0);
  const [activo, setActivo] = useState(true);
  const [montoFactu, setMontoFactu] = useState(true);
  const [desde, setDesde] = useState(0);

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [datos, setDatos] = useState();
  const [idFactxOrden, setIdFactxOrden] = useState(0);
  const [fechaUD, setFechaUD] = useState();

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const chkManual = useRef();
  const txtNumOperacion = useRef();
  const txtNumFactura = useRef();
  const txtNumControl = useRef();
  const txtFecha = useRef();
  const txtSubTotal = useRef();
  const txtOtros = useRef();
  const txtAjustes = useRef();
  const txtExento = useRef();
  const txtBaseImponible = useRef();
  const txtPorceIva = useRef();
  const txtMontoIva = useRef();
  const txtTotal = useRef();
  const txtIdCuenta = useRef();
  const txtNomBanco = useRef();
  const txtNumCuenta = useRef();
  const txtMotivo = useRef();
  const txtIdordenpago = useRef();
  const txtFechaConRef = useRef();

  const cmbMesRef = useRef();
  const cmbAnioRef = useRef();

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const blanquear = () => {
    setActivate(false);
    setActivo(true);
    setDeshabilitado(true);
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onDatos(datos);
    props.onHideCancelar();
    blanquear();
  };
  const handleInputNumChange = (event) => {
    event.preventDefault();
    if (event.target.id === "numoperacion") {
      validaSoloNumero(event);
    }

    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.which === 13) {
        if (event.target.id === "numoperacion") {
          txtNumFactura.current.focus();
        } else if (event.target.id === "numfactura") {
          txtNumControl.current.focus();
        } else if (event.target.id === "numcontrol") {
          txtFecha.current.focus();
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const seleccionarCuentaBancaria = (codigo) => {
    let campos = "*";
    let nomtab = "cuentabancaria";
    let nomid = "idcuentabancaria";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${codigo}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idcuentabancaria > 0) {
            txtIdCuenta.current.value = response.data.idcuentabancaria;
            txtNomBanco.current.value = response.data.nombre;
            txtNumCuenta.current.value = response.data.cuentabancaria;
            setDisabledInput(2);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Error.",
              texto: "¡Código i/o Cuenta Bancaria, No esta Registrado!",
              icono: "error",
            });
            txtIdCuenta.current.value = "";
            txtNomBanco.current.value = "";
            txtNumCuenta.current.value = "";
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleCuentaBancaria = (event) => {
    event.preventDefault();
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarCuentaBancaria(event.target.value);
      }
    }
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (!txtIdCuenta.current.value) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación.",
        texto: "Debe ingresar o seleccioanr una cuenta bancaria",
        icono: "informacion",
      });
      sigue = false;
      txtIdCuenta.current.focus();
    }

    if (sigue) {
      let reporte = "LibroAuxMensualA";

      let anio = parseInt(cmbAnioRef.current.value);
      let ini =
        cmbMesRef.current.value.length === 2
          ? '"' + anio + "-" + cmbMesRef.current.value + '-01"'
          : '"' + anio + "-0" + cmbMesRef.current.value + '-01"';

      let fechas = cmbMesRef.current.value.length === 2
        ? + anio + "-" + cmbMesRef.current.value + '-01'
        : + anio + "-0" + cmbMesRef.current.value + '-01';

      let prueba = moment(fechas.toString()).endOf('month');

      let fin =
        cmbMesRef.current.value.length === 2
          ? '"' +
          cmbAnioRef.current.value +
          "-" +
          cmbMesRef.current.value + '-' + moment(prueba).format('DD') + '"'
          : '"' +
          parseInt(cmbAnioRef.current.value) +
          "-0" +
          cmbMesRef.current.value + '-' + moment(prueba).format('DD') + '"';

      let desdec = cmbMesRef.current.value.length === 2
        ? "'" + anio + "-" + cmbMesRef.current.value + '-01' + "'"
        : "'" + anio + "-0" + cmbMesRef.current.value + '-01' + "'";

      let hasctac = cmbMesRef.current.value.length === 2
        ? "'" +
        cmbAnioRef.current.value +
        "-" +
        cmbMesRef.current.value + '-' + moment(prueba).format('DD') + "'"
        : "'" +
        parseInt(cmbAnioRef.current.value) +
        "-0" +
        cmbMesRef.current.value + '-' + moment(prueba).format('DD') + "'";

      let sql = "(doc_fechae between " + desdec + ' AND ' + hasctac + ")";
      let sql2 = "DESDE EL '" + ini + "' HASTA EL '" + fin + "'";
      let sql3 = "c.idcuentabancaria = " + txtIdCuenta.current.value;
      let sql4 = "AND true";
      let tit = cmbMesRef.current.value.length < 2 ? "0" + cmbMesRef.current.value + '/' + anio : cmbMesRef.current.value + '/' + anio
      let org = post.nombreorg

      window.open(
        op.reportes + "/finanzas?afiliado=" + afiliado + "&reporte=" + reporte +
        "&sql=" +
        encodeURIComponent(sql) +
        "&sql3=" +
        encodeURIComponent(sql3) +
        "&sql4=" +
        encodeURIComponent(sql4) +
        "&ini=" +
        encodeURIComponent(ini) +
        "&fin=" +
        encodeURIComponent(fin) +
        "&tit=" +
        encodeURIComponent(tit) +
        "&org=" +
        encodeURIComponent(org) +
        "&ciu=" +
        encodeURIComponent(' '),
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
      );
    }
  };

  const seleccionarFactura = () => {
    blanquear();
    var data = [];

    data.push({
      idfacturaxorden: idFactxOrden,
      numoperacion: txtNumOperacion.current.value,
      numfactura: txtNumFactura.current.value,
      numcontrol: txtNumControl.current.value,
      fecfactura: txtFecha.current.value,
      subtotal: parseFloat(
        txtSubTotal.current.value.replace(/\./g, "").replace(",", ".")
      ),
      otros: parseFloat(
        txtOtros.current.value.replace(/\./g, "").replace(",", ".")
      ),
      ajuste: parseFloat(
        txtAjustes.current.value.replace(/\./g, "").replace(",", ".")
      ),
      exento: parseFloat(
        txtExento.current.value.replace(/\./g, "").replace(",", ".")
      ),
      baseimponible: parseFloat(
        txtBaseImponible.current.value.replace(/\./g, "").replace(",", ".")
      ),
      porceiva: parseFloat(
        txtPorceIva.current.value.replace(/\./g, "").replace(",", ".")
      ),
      total: parseFloat(
        txtTotal.current.value.replace(/\./g, "").replace(",", ".")
      ),
    });
    setDatos(data);
    let msg = "";
    if (props.operacion === 1) {
      msg = "registro creado correctamente.";
    } else if (props.operacion === 2) {
      msg = "registro modificado correctamente.";
    } else if (props.operacion === 3) {
      msg = "registro eliminado correctamente.";
    }
    setMensaje({ mostrar: true, titulo: "Exito.", texto: msg, icono: "exito" });
  };

  const handleCancelaCuentaBancaria = () => {
    setMostrar5(false);
  };

  const handleAceptarCuentaBancaria = (datos) => {
    setMostrar5(false);
    setDisabledInput(2);
    txtIdCuenta.current.value = datos.idcuentabancaria;
    txtNomBanco.current.value = datos.nombre;
    txtNumCuenta.current.value = datos.cuentabancaria;
  };

  const LlenarComboAnio = () => {
    var n = new Date().getFullYear();
    var a = [];
    for (var i = n; i >= 2015; i--) {
      a.push({ anio: i });
    }
    cmbAnioRef.current.value = n;
    setCmbAnios(a);
    var meses = [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ];
    var m = [];
    for (var x = 0; x < 12; x++) {
      m.push({ nummes: x + 1, mes: meses[x] });
    }
    cmbMesRef.current.value = 1;
    setCmbMeses(m);
  };

  const catalogoCuentaBancaria = (e) => {
    e.preventDefault();
    setMostrar5(true);
  };

  const validarPeriodo = (event) => {
    setDesde(0);

    let fecPer =
      cmbAnioRef.current.value +
      "-" +
      cmbMesRef.current.value.toString().padStart(2, 0) +
      "-01";
    if (fecPer > moment(txtFechaConRef.current.value).format("YYYY-MM-DD")) {
      /*  setTitulo("Error");
         setMsg("La fecha de Conciliación no puede ser menor al periodo a conciliar");
         setMostrar(true); */
      cmbMesRef.current.value = 1;
      cmbAnioRef.current.value = new Date(
        txtFechaConRef.current.value
      ).getFullYear();
      let fecUD =
        cmbAnioRef.current.value +
        "-" +
        cmbMesRef.current.value.toString().padStart(2, 0) +
        "-" +
        new Date(cmbAnioRef.current.value, cmbMesRef.current.value, 0)
          .getDate()
          .toString()
          .padStart(2, 0);
      setFechaUD(fecUD);
      return false;
    } else {
      let fecUD =
        cmbAnioRef.current.value +
        "-" +
        cmbMesRef.current.value.toString().padStart(2, 0) +
        "-" +
        new Date(cmbAnioRef.current.value, cmbMesRef.current.value, 0)
          .getDate()
          .toString()
          .padStart(2, 0);
      setFechaUD(fecUD);
      return true;
    }
  };

  useEffect(() => { }, []);

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setActivo(false);
        LlenarComboAnio();
      }}
    >
      <Modal.Header className="azulGradiant header-modal">
        <div className="fw-bold text-light">
          <h3>Movimientos Bancarios Según Libros</h3>
        </div>
        <button
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Dimmer active={activate} inverted>
          <Loader inverted>cargando...</Loader>
        </Dimmer>
        <div className="col-md-12 row mx-auto px-0 border-azul rounded">
          <fieldset className="row px-0 rounded mx-auto mb-2">
            <legend
              className="float-none m-0 w-auto fw-bold"
              style={{ fontSize: 18 }}
            >
              Datos del Banco
            </legend>

            <div className="input-group input-group-sm col-md-5 mb-3">
              <label className="input-group-text fs-6" id="inputGroup-sizing-sm">
                CODIGO:
              </label>
              <input
                type="text"
                className="form-control text-uppercase fs-6 h-100"
                disabled={
                  disabledInput === 1
                    ? false
                    : disabledInput === 2
                      ? false
                      : true
                }
                onChange={handleInputNumChange}
                onKeyUp={handleCuentaBancaria}
                onBlur={handleInputNumChange}
                /* disabled={habiprov} */ ref={txtIdCuenta}
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                id="idcuenta"
              />
              <button
                /* disabled={habiprov} */ onClick={catalogoCuentaBancaria}
                className="btn btn-sm  btn-info"
              >
                <i className="fa fa-search"></i>{" "}
              </button>
            </div>
            <div className="col-md-7"></div>

            <div className="input-group input-group-sm col-md-12 mb-3">
              <label className="input-group-text fs-6" id="inputGroup-sizing-sm">
                BANCO:
              </label>
              <input
                type="text"
                className="form-control text-uppercase fs-6 h-100"
                maxLength={12}
                disabled={true}
                ref={txtNomBanco}
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                id="inputDireccion"
              />
              <input
                type="text"
                className="form-control text-uppercase fs-6 h-100 px-1"
                ref={txtNumCuenta}
                disabled={true}
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                id="inputDireccion"
              />
            </div>
            <div className="input-group input-group-sm col-md-6">
              <label className="input-group-text fs-6" id="inputGroup-sizing-sm">
                MES:
              </label>
              <select
                name=""
                className="form-select fs-6 text-uppercase"
                disabled={disabledInput === 2 ? false : true}
                ref={cmbMesRef}
                onChange={validarPeriodo}
              >
                {cmbMeses &&
                  cmbMeses.map((meses) => (
                    <option key={meses.nummes} value={meses.nummes}>
                      {meses.mes}
                    </option>
                  ))}
                ;
              </select>
            </div>

            <div className="input-group input-group-sm col-md-4">
              <label className="input-group-text fs-6" id="inputGroup-sizing-sm">
                AÑO:
              </label>
              <select
                name=""
                className="form-select text-right fs-6"
                disabled={disabledInput === 2 ? false : true}
                id="anio"
                ref={cmbAnioRef}
                onChange={validarPeriodo}
              >
                {cmbAnios &&
                  cmbAnios.map((anios) => (
                    <option key={anios.anio} value={anios.anio}>
                      {anios.anio}
                    </option>
                  ))}
                ;
              </select>
            </div>

            <div className="col-md-3"></div>
          </fieldset>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          ref={btnAcepta}
          onClick={onChangeValidar}
          disabled={activo}
          style={{ margin: "1px" }}
          className="fw-bold btn btn-primary btn-sm rounded-pill"
        >
          <i className="far fa-check-circle"></i> Imprimir
        </button>
        <button
          type="button"
          ref={btnCancela}
          onClick={cancelar}
          style={{ margin: "1px" }}
          className="fw-bold btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"></i> Cancelar
        </button>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />

      <CatalogoCuentaBancaria
        show={mostrar5}
        onHideCancelar={handleCancelaCuentaBancaria}
        onHideAceptaCatalogo={handleAceptarCuentaBancaria}
      />
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/finanzas/impMovBanSegunLibro.js